// NOTE: the fallback for a page whose chunk is still loading, it mirrors the hero and band every page shares
import Skeleton from './Skeleton'

const COPY_PLACEHOLDERS = [
	{ id: 'first', className: 'w-full' },
	{ id: 'second', className: 'w-full' },
	{ id: 'third', className: 'w-4/5' }
]

const PageSkeleton = () => (
	<div role="status" aria-label="Loading page">
		{/* Hero */}
		<section className="bg-white">
			<div className="mx-auto w-full max-w-7xl px-5 py-16 sm:px-8 md:py-[88px]">
				<div className="grid items-center gap-10 md:grid-cols-2 md:gap-14">
					<div>
						<Skeleton className="mb-[18px] h-4 w-[140px]" />
						<Skeleton className="mb-[22px] h-[38px] w-full max-w-[420px] sm:h-11 md:h-[56px]" />

						<div className="mb-8 max-w-[46ch]">
							{COPY_PLACEHOLDERS.map(({ id, className }) => (
								<Skeleton key={id} className={`mb-2.5 h-5 ${className}`} />
							))}
						</div>

						<Skeleton className="h-[46px] w-[190px] rounded-[10px]" />
					</div>

					<div className="relative h-[320px] min-w-0 md:h-[420px]">
						<Skeleton className="absolute inset-0 h-full w-full rounded-2xl" />
					</div>
				</div>
			</div>
		</section>

		{/* Band */}
		<section className="border-y border-slate-200 bg-slate-50">
			<div className="mx-auto w-full max-w-7xl px-5 py-16 sm:px-8">
				<Skeleton className="mx-auto mb-9 h-8 w-[280px] md:w-[360px]" />

				<div className="grid gap-6 md:grid-cols-3">
					{COPY_PLACEHOLDERS.map(({ id }) => (
						<Skeleton key={id} className="h-[180px] w-full rounded-2xl" />
					))}
				</div>
			</div>
		</section>
	</div>
)

export default PageSkeleton
